import React from 'react';
import GatsbyLink from 'gatsby-link';

export default ({to, ...props}) => {
  let isExternalLink = false;
  if (/^https?:\/\/.*/.test(to)) {
    isExternalLink = true;
  }

  return isExternalLink ?
    <a href={to} {...props} /> :
    <GatsbyLink to={to} {...props} />;
}



// WEBPACK FOOTER //
// ./src/components/link.js